
import { useIonToast } from "@ionic/react";

interface UseToastOptions {
  color?: string;
  cssClass?: string;
  duration?: number;
  icon?: string;
  position?: "top" | "bottom" | "middle";
}

const useToast = (options?: UseToastOptions) => {
  const [present] = useIonToast();

  return (message: string) => {
    if (!message) return; // Prevent rendering if message is empty
    present({
      message,
      duration: 2000,
      cssClass: "custom-toast",
      ...options,
    });
  };
};

export default useToast;